import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
  EnterPriceTypes: [],
};

const slice = createSlice({
  name: 'EnterPrices',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET EnterPriceManagement
    getAllEnterPriceTypesSuccess(state, action) {
      state.EnterPriceTypes = action.payload.data;
    },
    // GET EnterPriceManagement
    getEnterPricesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateEnterPrices(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      state.checkout.activeStep = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllEnterPriceTypes() {
  return async () => {
    try {
      const response = await get(`allEnterPriceTypes`);
      if (response.status) {
        dispatch(slice.actions.getAllEnterPriceTypesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getSupplierPricing() {
  return async () => {
    try {
      const response = await get(`SupplierPricing`);
      if (response.status) {
        dispatch(slice.actions.getEnterPricesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addEnterPrice(body) {
  return async () => {
    try {
      const response = await post(`SupplierPricing`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateEnterPrices(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
